<template>
  <div class="slick-carousel">
    <vueper-slides
      :autoplay="autoplayCard"
      :pause-on-hover="true"
      :touchable="true"
      fade
      :fixed-height="fixedHeight"
      :slide-ratio="1 / 2"
      fractions
      :arrows="arrows"
    >
      <vueper-slide
        v-for="(slide, i) in images"
        :key="i"
        :image="slide"
      >
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  components: {
    VueperSlides,
    VueperSlide,
  },
  computed: {
    fixedHeight() {
      const height = this.height || this.defaultHeight;

      return `${height}px`
    },
    autoplayCard() {
      return this.autoplay || false
    },
    defaultHeight() {
      let heightImages
      if (this.windowHeight > 1200) {
        heightImages = 500
      } else if (this.windowHeight > 768) {
        heightImages = 400
      } else {
        heightImages = 250
      }

      return heightImages
    }
  },
  props: ["height", "images", "autoplay", "arrows"],
  data() {
    return {
      windowHeight: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/lib/components/slickCarousel.vue